<template>
  <audio
    ref="audio"
    preload="none"
    @ended="ended"
    @loadeddata="loadeddata"
    @play="play"
    @playing="playing"
    @pause="pause"
    @timeupdate="timeupdate"
    @suspend="suspend"
  />
</template>

<script>
import playerjs from 'player.js'
export default {
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  data () {
    return {
      receiver: false
    }
  },
  computed: {
    audio () { return this.store.state.audio },
    episode () { return this.store.state.episode },
    isLoaded () { return this.store.state.isLoaded },
    isPlaying () { return this.store.state.isPlaying },
    isWaiting () { return this.store.state.isWaiting }
  },
  watch: {
    episode (val, oldVal) {
      if (!oldVal) return

      if (val.enclosure_url !== oldVal.enclosure_url) {
        this.store.setLoaded(0)
        this.store.setAudioCurrentTime(0)
        this.store.setCurrentTime(0)
        this.store.setIsWaiting(true)
        this.loading()

        if (this.isPlaying) {
          this.audio.play()
        }
      }
    }
  },
  mounted () {
    this.store.setAudio(this.$refs.audio)
    this.initializeReceiver()
  },
  methods: {
    ended () {
      this.receiver.emit('ended')
      this.store.sendCompleteEvent()
      this.store.sendPlayEvent()
    },
    // For jPlayer and making this compatible with Medium/Embedly
    initializeReceiver () {
      this.receiver = new playerjs.Receiver()

      this.receiver.on('getDuration', (callback) => { callback(this.store.state.audio.duration) })
      this.receiver.on('getLoop', (callback) => { callback(this.store.state.audio.loop || false) })
      this.receiver.on('getCurrentTime', (callback) => {
        const currentTime = this.audio.currentTime
        callback(currentTime)
      })
      this.receiver.on('getMuted', (callback) => { callback(this.store.state.isMuted) })
      this.receiver.on('getPaused', (callback) => {
        const isPlaying = !this.store.state.isPlaying
        callback(isPlaying)
      })
      this.receiver.on('getVolume', (callback) => {
        const volume = this.store.state.audio.volume * 100
        callback(volume)
      })

      // Action calls
      this.receiver.on('mute', () => { this.store.setMute(true) })
      this.receiver.on('unmute', () => { this.store.setMute(false) })
      this.receiver.on('pause', () => {
        this.audio.pause()
      })
      this.receiver.on('play', () => {
        this.audio.play()
      })

      // Set calls
      this.receiver.on('setCurrentTime', (currentTime) => {
        this.store.setAudioCurrentTime(currentTime)
        this.store.setCurrentTime(currentTime)
        this.receiver.emit('setCurrentTime')
      })
      this.receiver.on('setLoop', (loop) => { this.store.setLoop(loop) })
      this.receiver.on('setVolume', (volume) => { this.setVolume(volume) })

      // Tell the receiver that we're all set up
      this.receiver.ready()
    },
    loadeddata (e) {
      this.store.setVolume(this.store.state.volume)
      this.store.setDuration(this.store.state.audio.duration)
      this.store.setMute(false)
      this.loading()

      // When first loaded we need to make sure we honor the timejump
      // that will set our elapsed time
      this.store.state.audio.currentTime = this.store.state.currentTime
    },
    loading () {
      let loaded = 0

      if (this.audio.buffered.length) loaded = this.audio.buffered.end(0) / this.store.state.audio.duration

      this.store.setLoaded(loaded)

      if (loaded < 1) setTimeout(this.loading, 100)
    },
    play () {
      this.store.setIsPlaying(true)
      this.receiver.emit('play')
    },
    playing () {},
    pause () {
      this.store.setIsPlaying(false)
      this.receiver.emit('pause')
    },
    setVolume (volume) {
      this.store.setVolume(volume / 100)
      this.receiver.emit('setVolume')
    },
    timeupdate () {
      this.store.setCurrentTime(this.audio.currentTime)
      this.receiver.emit('timeupdate', {
        seconds: this.audio.currentTime,
        duration: this.audio.duration
      })
    },
    suspend () {}
  }
}
</script>
